'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _PlatformApi2 = require('./PlatformApi');

var _PlatformApi3 = _interopRequireDefault(_PlatformApi2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable sort-keys */
var endpoints = {
  api: {
    dashboards: {
      selection: {
        many: '/api/dashboards/campaign/selection_page',
        queryParams: ['activeOrder', 'agencyCompany', 'impressionsOrderedMin', 'impressionsOrderedMax', 'startDate', 'endDate', 'subMediaTypes', 'companyIds', 'searchBy', 'order_by', 'limit', 'offset']
      },
      ihmCampaign: {
        details: {
          one: '/api/dashboards/campaign/{record}/details',
          params: {
            record: 'initiativeId'
          }
        },
        initiativeSummary: {
          one: '/api/dashboards/campaign/{record}/initiative_summary',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_items', 'include_line_items', 'media_types']
        },
        totalHeroMetrics: {
          one: '/api/dashboards/campaign/{record}/campaign_total_hero_metrics',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_items', 'include_line_items', 'media_types']
        },
        campaignDailyStats: {
          one: '/api/dashboards/campaign/{record}/campaign_daily_impressions',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_items', 'include_line_items', 'media_types']
        },
        campaignConversionDailyStats: {
          one: '/api/dashboards/campaign/{record}/campaign_conversion_daily_stats',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date']
        },
        campaignDailyImpsClicks: {
          one: '/api/dashboards/campaign/{record}/campaign_daily_imps_and_clicks',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_items', 'include_line_items', 'media_types']
        },
        lifetimeReachFrequency: {
          one: '/api/dashboards/campaign/{record}/lifetime_reach_freq',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_items', 'include_line_items', 'media_types']
        },
        dailyReachAndFrequency: {
          one: '/api/dashboards/campaign/{record}/daily_reach_freq',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_items', 'include_line_items', 'media_types']
        },
        publisherStats: {
          one: '/api/dashboards/campaign/{record}/publisher_stats',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_items', 'include_line_items', 'media_types']
        },
        deviceModel: {
          one: '/api/dashboards/campaign/{record}/device_model',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_items', 'include_line_items', 'media_types']
        },
        device: {
          one: '/api/dashboards/campaign/{record}/device',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_items', 'include_line_items', 'media_types']
        },
        deviceEvents: {
          one: '/api/dashboards/campaign/{record}/device/events',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_items', 'include_line_items', 'media_types']
        },
        tacticPerformanceStats: {
          one: '/api/dashboards/campaign/{record}/tactic_performance',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_items', 'include_line_items', 'media_types']
        },
        ott: {
          marketplace: {
            one: '/api/dashboards/campaign/{record}/ott/marketplace',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_line_items', 'include_line_items', 'media_types']
          },
          hourWatched: {
            one: '/api/dashboards/campaign/{record}/ott/hour_watched',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_line_items', 'include_line_items', 'media_types']
          },
          impressionsByDayStats: {
            one: '/api/dashboards/campaign/{record}/ott/by_day',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_line_items', 'include_line_items', 'media_types']
          },
          impressionsByDayPartStats: {
            one: '/api/dashboards/campaign/{record}/ott/daypart',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_line_items', 'include_line_items', 'media_types']
          }
        },
        campaignMediaTypeStats: {
          one: '/api/dashboards/campaign/{record}/campaign_media_types',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_items', 'include_line_items', 'media_types']
        },
        landingPagePerformanceStats: {
          one: '/api/dashboards/campaign/{record}/landing_page_performance_stats',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_items', 'include_line_items', 'media_types']
        },
        landingPagePerformanceStatsByCreative: {
          one: '/api/dashboards/campaign/creative/{record}/landing_page_performance_stats',
          params: {
            record: 'creativeId'
          }
        },
        campaignGeoStoreVisitStats: {
          one: '/api/dashboards/campaign/{record}/campaign_store_visit_stats',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'include_line_items', 'exclude_line_items']
        },
        campaignGeoStoreVisitFlags: {
          one: '/api/dashboards/campaign/{record}/campaign_store_visit_flags',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'include_line_items', 'exclude_line_items']
        },
        campaignGeoCityStats: {
          one: '/api/dashboards/campaign/{record}/geo_city_stats',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'include_line_items', 'exclude_line_items']
        },
        campaignGeoStateStats: {
          one: '/api/dashboards/campaign/{record}/geo_state_stats',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'include_line_items', 'exclude_line_items']
        },
        campaignGeoDmaStats: {
          one: '/api/dashboards/campaign/{record}/geo_dma_stats',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'include_line_items', 'exclude_line_items']
        },
        campaignSocialEngagements: {
          one: '/api/dashboards/campaign/{record}/social_engagements',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'include_line_items', 'exclude_line_items']
        },
        campaignVideoViewStats: {
          one: '/api/dashboards/campaign/{record}/video_view_stats',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'include_line_items', 'exclude_line_items']
        },
        campaignCreativeStats: {
          one: '/api/dashboards/campaign/{record}/campaign_creative_stats',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['activeCreativeToggle', 'start_date', 'end_date', 'media_types', 'include_line_items', 'exclude_line_items', 'offset', 'itemsPerPage', 'orderFields']
        },
        campaignAgeStats: {
          one: '/api/dashboards/campaign/{record}/campaign_age_stats',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'include_line_items', 'exclude_line_items']
        },
        campaignGenderStats: {
          one: '/api/dashboards/campaign/{record}/campaign_gender_stats',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'include_line_items', 'exclude_line_items']
        },
        campaignAudioTopNetwork: {
          one: '/api/dashboards/campaign/{record}/audio_top_network',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'include_line_items', 'exclude_line_items']
        },
        campaignAudioAdCompletion: {
          one: '/api/dashboards/campaign/{record}/campaign_audio_ad_completion',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'include_line_items', 'exclude_line_items']
        },
        audioTopStations: {
          one: '/api/dashboards/campaign/{record}/campaign_audio_top_stations',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'include_line_items', 'exclude_line_items']
        },
        campaignBroadcastDelivery: {
          one: '/api/dashboards/campaign/{record}/broadcast_delivery',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'include_line_items', 'exclude_line_items']
        },
        campaignBroadcastStation: {
          one: '/api/dashboards/campaign/{record}/campaign_broadcast_stations',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'include_line_items', 'exclude_line_items']
        },
        broadcastImpressionGoals: {
          one: '/api/dashboards/campaign/broadcast_impression_goals',
          queryParams: ['initiative_ids']
        },
        conversionPerformance: {
          one: '/api/dashboards/campaign/{record}/conversion_performance',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'offset', 'orderFields', 'itemsPerPage']
        },
        campaignBroadcastSpotPerformance: {
          one: '/api/dashboards/campaign/{record}/campaign_broadcast_spot_performance',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'include_line_items', 'exclude_line_items', 'display_by']
        },
        campaignDcmTotalHeroMetrics: {
          one: '/api/dashboards/campaign/{record}/campaign_dcm_total_hero_metrics',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_items', 'include_line_items', 'media_types']
        },
        campaignDcmDailyImpsAndClicks: {
          one: '/api/dashboards/campaign/{record}/dcm_daily_imps_and_clicks',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_items', 'include_line_items', 'media_types']
        },
        campaignMagellanConversionPerformance: {
          one: '/api/dashboards/campaign/{record}/magellan_conversion_performance',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_items', 'include_line_items', 'media_types', 'itemsPerPage', 'offset', 'orderFields', 'is_grouped_mode']
        },
        campaignMagellanAdConversionPerformance: {
          one: '/api/dashboards/campaign/{record}/magellan_ad_conversion_performance',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_items', 'include_line_items', 'media_types', 'itemsPerPage', 'offset', 'orderFields']
        },
        campaignDcmPlacementPerformance: {
          one: '/api/dashboards/campaign/{record}/dcm_placement_performance',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'offset', 'itemsPerPage', 'orderFields']
        }
      },
      ihmCompany: {
        companyTotalStats: {
          one: '/api/dashboards/company/{record}/company_total_hero_metrics',
          params: {
            record: 'companyId'
          },
          queryParams: ['exclude_initiatives', 'include_initiatives', 'media_types', 'start_date', 'end_date']
        },
        companyDailyStats: {
          one: '/api/dashboards/company/{record}/company_daily_impressions',
          params: {
            record: 'companyId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_initiatives', 'include_initiatives', 'media_types']
        },
        companyDailyMediaTypeImpStats: {
          one: '/api/dashboards/company/{record}/company_daily_imps',
          params: {
            record: 'companyId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_initiatives', 'include_initiatives', 'media_types']
        },
        companyDailyMediaTypeClickStats: {
          one: '/api/dashboards/company/{record}/company_daily_clicks',
          params: {
            record: 'companyId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_initiatives', 'include_initiatives', 'media_types']
        },
        companyMediaTypeStats: {
          one: '/api/dashboards/company/{record}/company_media_types',
          params: {
            record: 'companyId'
          },
          queryParams: ['exclude_initiatives', 'media_types', 'include_initiatives', 'start_date', 'end_date']
        },
        publisherStats: {
          one: '/api/dashboards/company/{record}/publisher_stats',
          params: {
            record: 'companyId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_initiatives', 'include_initiatives', 'media_types']
        },
        companyVideoViewStats: {
          one: '/api/dashboards/company/{record}/video_view_stats',
          params: {
            record: 'companyId'
          },
          queryParams: ['exclude_initiatives', 'include_initiatives', 'media_types', 'start_date', 'end_date']
        },
        companyCreativeStats: {
          one: '/api/dashboards/company/{record}/company_creative_stats',
          params: {
            record: 'companyId'
          },
          queryParams: ['activeCreativeToggle', 'exclude_initiatives', 'include_initiatives', 'media_types', 'start_date', 'end_date', 'offset', 'orderFields', 'itemsPerPage']
        },

        deviceModel: {
          one: '/api/dashboards/company/{record}/device_model',
          params: {
            record: 'companyId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_initiatives', 'include_initiatives', 'media_types']
        },
        device: {
          one: '/api/dashboards/company/{record}/device',
          params: {
            record: 'companyId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_initiatives', 'include_initiatives', 'media_types']
        },
        deviceEvents: {
          one: '/api/dashboards/company/{record}/device/events',
          params: {
            record: 'companyId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_initiatives', 'include_initiatives', 'media_types']
        },
        tacticPerformanceStats: {
          one: '/api/dashboards/company/{record}/tactic_performance_stats',
          params: {
            record: 'companyId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_initiatives', 'include_initiatives', 'media_types']
        },
        geoCityStats: {
          one: '/api/dashboards/company/{record}/geo_city_stats',
          params: {
            record: 'companyId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'exclude_initiatives', 'include_initiatives']
        },
        geoStateStats: {
          one: '/api/dashboards/company/{record}/geo_state_stats',
          params: {
            record: 'companyId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'exclude_initiatives', 'include_initiatives']
        },
        geoDmaStats: {
          one: '/api/dashboards/company/{record}/geo_dma_stats',
          params: {
            record: 'companyId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'exclude_initiatives', 'include_initiatives']
        },
        socialEngagements: {
          one: '/api/dashboards/company/{record}/social_engagements',
          params: {
            record: 'companyId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'exclude_initiatives', 'include_initiatives']
        },
        geoStoreVisitStats: {
          one: '/api/dashboards/company/{record}/company_store_visit_stats',
          params: {
            record: 'companyId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'exclude_initiatives', 'include_initiatives']
        },
        geoStoreVisitFlags: {
          one: '/api/dashboards/company/{record}/company_store_visit_flags',
          params: {
            record: 'companyId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'exclude_initiatives', 'include_initiatives']
        },
        landingPagePerformanceStats: {
          one: '/api/dashboards/company/{record}/landing_page_performance_stats',
          params: {
            record: 'companyId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_initiatives', 'include_initiatives', 'media_types']
        },
        companyAudioTopNetwork: {
          one: '/api/dashboards/company/{record}/audio_top_network',
          params: {
            record: 'companyId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_initiatives', 'include_initiatives', 'media_types']
        },
        companyAudioAdCompletion: {
          one: '/api/dashboards/company/{record}/company_audio_ad_completion',
          params: {
            record: 'companyId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_initiatives', 'include_initiatives', 'media_types']
        },
        companyBroadcastDelivery: {
          one: '/api/dashboards/company/{record}/broadcast_delivery',
          params: {
            record: 'companyId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_initiatives', 'include_initiatives', 'media_types']
        },
        companyBroadcastStations: {
          one: '/api/dashboards/company/{record}/company_broadcast_stations',
          params: {
            record: 'companyId'
          },
          queryParams: ['start_date', 'end_date', 'include_initiatives', 'exclude_initiatives']
        },
        ott: {
          impressionsByDayStats: {
            one: '/api/dashboards/company/{record}/ott/by_day',
            params: {
              record: 'companyId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_initiatives', 'include_initiatives', 'media_types']
          },
          impressionsByDayPartStats: {
            one: '/api/dashboards/company/{record}/ott/daypart',
            params: {
              record: 'companyId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_initiatives', 'include_initiatives', 'media_types']
          },
          marketplace: {
            one: '/api/dashboards/company/{record}/ott/marketplace',
            params: {
              record: 'companyId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_initiatives', 'include_initiatives', 'media_types']
          },
          hourWatched: {
            one: '/api/dashboards/company/{record}/ott/hour_watched',
            params: {
              record: 'companyId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_initiatives', 'include_initiatives', 'media_types']
          }
        },
        audioTopStations: {
          one: '/api/dashboards/company/{record}/company_audio_top_stations',
          params: {
            record: 'companyId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_initiatives', 'include_initiatives', 'media_types']
        },
        companyBroadcastSpotPerformance: {
          one: '/api/dashboards/company/{record}/company_broadcast_spot_performance',
          params: {
            record: 'companyId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_initiatives', 'include_initiatives', 'media_types', 'display_by']
        },
        companyDcmTotalHeroMetrics: {
          one: '/api/dashboards/company/{record}/company_dcm_total_hero_metrics',
          params: {
            record: 'companyId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_items', 'include_line_items', 'media_types']
        },
        companyAgeStats: {
          one: '/api/dashboards/company/{record}/company_age_stats',
          params: {
            record: 'companyId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'include_initiatives', 'exclude_initiatives']
        },
        companyGenderStats: {
          one: '/api/dashboards/company/{record}/company_gender_stats',
          params: {
            record: 'companyId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'include_initiatives', 'exclude_initiatives']
        },
        companyDcmDailyImpsAndClicks: {
          one: '/api/dashboards/company/{record}/dcm_daily_imps_and_clicks',
          params: {
            record: 'companyId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_items', 'include_line_items', 'media_types']
        },
        companyDcmPlacementPerformance: {
          one: '/api/dashboards/company/{record}/dcm_placement_performance',
          params: {
            record: 'companyId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'offset', 'itemsPerPage', 'orderFields']
        }
      }
    }
  }

  /* eslint-enable sort-keys */

};var defaultOptions = {
  prefix: '/platform_dashboards'
};

var PlatformDashboardsApi = function (_PlatformApi) {
  (0, _inherits3.default)(PlatformDashboardsApi, _PlatformApi);

  function PlatformDashboardsApi(options) {
    (0, _classCallCheck3.default)(this, PlatformDashboardsApi);

    var o = (0, _assign2.default)({}, defaultOptions, options);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PlatformDashboardsApi.__proto__ || (0, _getPrototypeOf2.default)(PlatformDashboardsApi)).call(this, o));

    _this._endpoints = endpoints;
    return _this;
  }

  return PlatformDashboardsApi;
}(_PlatformApi3.default);

exports.default = PlatformDashboardsApi;
//# sourceMappingURL=PlatformDashboardsApi.js.map